import React from 'react';
import rgbHex from 'rgb-hex';
import * as chroma from 'chroma-js';
import Colours from '../../constants/colours';

export function getImageData(
  imageRef: React.MutableRefObject<HTMLImageElement>,
  canvasRef: React.MutableRefObject<HTMLCanvasElement>
): ImageData {
  // create small inner bounding box to read from
  // rather than reading the whole image
  const boundingWidth = 0.1;
  const boundingOffsetY = 100;
  const w = imageRef.current.naturalWidth;
  const h = imageRef.current.naturalHeight;
  const x = Math.floor(((1 - boundingWidth) * w) / 2);
  const y = Math.floor(h / 2 + boundingOffsetY);

  const canvas = canvasRef.current;
  const ctx = canvas.getContext('2d');

  canvas.width = w;
  canvas.height = h;

  ctx.drawImage(imageRef.current, 0, 0);

  return ctx.getImageData(x, y, w * boundingWidth, 30);
}

export function getCommonColours(
  imageData: Uint8ClampedArray,
  limit: number = 8
) {
  const colours = new Map<string, number>();

  for (let channel = 0; channel < imageData.length; channel += 4) {
    const r = imageData[channel];
    const g = imageData[channel + 1];
    const b = imageData[channel + 2];

    const hex = rgbHex(r, g, b);

    if (colours.has(hex)) {
      colours.set(hex, colours.get(hex) + 1);
    } else {
      colours.set(hex, 1);
    }
  }

  return new Map<string, number>(
    [...colours.entries()].sort((a, b) => b[1] - a[1]).slice(0, limit)
  );
}

export function getForegroundColour(colours: Map<string, number>) {
  const average = chroma.average(Array.from(colours.keys()));
  const withWhite = chroma.contrast(average.hex(), Colours.white);
  const withBlack = chroma.contrast(average.hex(), Colours.black);

  return withBlack > withWhite ? Colours.black : Colours.white;
}
